import { SEO } from "../components/SEO";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { HowItWorks } from "../components/landing/HowItWorks";
import { VisualBreak } from "../components/landing/VisualBreak";
import { CalculatorCard } from "../components/landing/RelatedCalculators";
import { FinalCTA } from "../components/landing/FinalCTA";
import { Footer } from "../components/landing/Footer";
import { Reveal } from "../components/Reveal";
import { PAGES, INDEX_PAGE } from "../config/pages";
import { SITE } from "../config/site";
import { usePagesData } from "../hooks/usePagesData";

export default function IndexPage() {
  const apiPages = usePagesData();
  const source = apiPages ? { ...PAGES, ...apiPages } : PAGES;
  const list = Object.values(source).filter((p) => !p.alias);
  return (
    <>
      <SEO
        title={INDEX_PAGE.seoTitle}
        description={INDEX_PAGE.metaDescription}
        image={INDEX_PAGE.heroImage}
      />
      <Navbar />
      <main data-testid="index-page">
        <Hero
          kicker={INDEX_PAGE.kicker}
          lines={INDEX_PAGE.h1Lines}
          intro={INDEX_PAGE.intro}
          primaryCta={INDEX_PAGE.primaryCta}
          secondaryCta={INDEX_PAGE.secondaryCta}
          image={INDEX_PAGE.heroImage}
          imageAlt={INDEX_PAGE.heroImageAlt}
          testidPrefix="index-hero"
        />
        <Marquee />

        <section id="calculators" className="bg-ink-bg py-24 sm:py-32" data-testid="calculators-index-section">
          <div className="mx-auto max-w-6xl px-6">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.35em] text-accent">The Calculators</p>
              <h2 className="mt-4 max-w-2xl font-display text-3xl uppercase leading-none tracking-tight text-ink-text sm:text-4xl lg:text-5xl">
                Pick your trade. Get your numbers.
              </h2>
              <p className="mt-6 max-w-xl leading-relaxed text-ink-muted">
                Each calculator has its own field guide, worked examples and FAQ — everything you need to order materials with confidence.
              </p>
            </Reveal>
            <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {list.map((page, i) => (
                <Reveal key={page.slug} delay={(i % 3) * 0.1}>
                  <CalculatorCard page={page} />
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        <HowItWorks />
        <VisualBreak image={INDEX_PAGE.visualImage} imageAlt={INDEX_PAGE.visualImageAlt} stat={INDEX_PAGE.visualStat} />
        <FinalCTA
          ctaLabel="Open MatCalc360"
          ctaHref={SITE.appBaseUrl}
          note="15 tools. Free. No login."
        />
      </main>
      <Footer />
    </>
  );
}
